import { createClient } from "@supabase/supabase-js";
import { SUPABASE_KEYS } from "../configs/secrets";

const supabase = createClient(SUPABASE_KEYS.dbUrl, SUPABASE_KEYS.dbAnonKey);

export default supabase;
